import React from 'react';
import styled, { css } from 'styled-components';

import { useOptionContext } from './option-context';
import { TileOriginalPrice } from './tile-original-price';
import { TileDiscountLabel } from './tile-discount-label';

/** Convenience wrapper rendering TileOriginalPrice + TileDiscountLabel with shared layout. Renders nothing when no discount applies. */
export function TileDiscountedPrice(): JSX.Element | null {
  const { originalPrice, discountLabel, hasMultipleOptions } = useOptionContext();

  if (!discountLabel || !originalPrice) {
    return null;
  }

  return (
    <Wrapper $hasMultipleOptions={hasMultipleOptions}>
      <TileOriginalPrice />
      <TileDiscountLabel />
    </Wrapper>
  );
}

const Wrapper = styled.span<{ $hasMultipleOptions?: boolean }>`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  font-size: var(--cms-font-size, 10px);
  gap: 2px;
  justify-content: center;
  line-height: 1;
  margin-top: 4px;

  ${({ $hasMultipleOptions }) =>
    $hasMultipleOptions &&
    css`
      @media screen and (min-width: 740px) {
        flex-direction: column;
      }
    `}
`;
